$(function(){
  checkSwiper();
  $(window).on("resize", function(){
    checkSwiper();
  })
})

function checkSwiper(){
  if($(".new-mp-variants-swiper").length > 0){
    if($(window).width() < 769){
      $(".new-mp-variants-swiper").attr("centered-slides", "true");
      if($(".new-mp-match-variant").length > 0){
        let ind = parseInt($(".new-mp-match-variant").attr("data-index"));
        $(".new-mp-variants-swiper")[0].swiper.slideTo(ind);
      }
    }
    else{
      $(".new-mp-variants-swiper").removeAttr("centered-slides");
    }
  }
  if($(".new-swt-image-wrapper .new-swt-thumb-swiper").length > 0){
    if($(window).width() < 1025){
      $(".new-swt-image-wrapper .new-swt-thumb-swiper").removeAttr("direction");
    }
    else{
      $(".new-swt-image-wrapper .new-swt-thumb-swiper").attr("direction", "vertical");
    }
  }
}

$(document).on("click", ".new-mp-variant-atc", function(){
  let $this = $(this);
  $this.addClass("active");
  let goToCheckout = $(this).attr("data-checkout");
  let formData = {};
  if($(this).attr("data-preorder") == "true"){
    formData = {
    'items': [{
      'id': $this.attr("data-id"),
      'quantity': 1,
        properties: {
          '_preorder': 'true'
        }
      }]
    };
  }
  else{
    formData = {
    'items': [{
      'id': $this.attr("data-id"),
      'quantity': 1
      }]
    };
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      if(goToCheckout == "true"){
        location.href = '/checkout';
      }
      else{
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(".new-mp-cart-btn").click(function(){
  $(".js-drawer-open-cart > span").trigger("click");
})

$(".new-redirect--link").click(function(){
  if($(this).attr("href").indexOf("#") != -1){
    if($($(this).attr("href")).length > 0){
      $('html, body').animate({scrollTop: $($(this).attr("href")).offset().top}, 1000);
    }
  }
})

$(".new-faqs-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".new-faqs-text").slideToggle(300);
})

$(document).on("change", "[data-variant-input]", function(){
  let v = $(this).closest("[data-product-blocks]").find("[data-product-select]").val();
  let textWrapper = $(this).closest("[data-product-blocks]").find(".new-preorder-text");
  let lineItemWrapper = $(this).closest("[data-product-blocks]").find(".new-preorder-line-item");
  let btn = $(this).closest("[data-product-blocks]").find(".new-main--atc");
  textWrapper.empty();
  lineItemWrapper.empty();
  btn.removeClass("new--preorder");
  if ($(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).length > 0){
    let isPreorder = $(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).attr("data-preorder");
    let preorderText = $(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).attr("data-preorder-text");
    if(isPreorder == "true"){
      lineItemWrapper.html(`<input type="text" name="properties[Preorder]" value="true" />`);
      btn.addClass("new--preorder");
      if(preorderText != "none"){
        textWrapper.text(preorderText);
      }
    }
    if($(".new-sticky-atc-options").length > 0){
      let name = $(this).attr("name");
      let val = $(this).val();
      $(`.new-sticky-atc-options[data-name="${name}"] summary strong`).text(val);
    }
    if($(".new-sticky-atc-btn").length > 0){
      let available = $(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).attr("data-available");
      if(available == "false"){
        $(".new-sticky-atc-btn").addClass("new-sticky-atc--sold");
        $(".new-sticky-atc-btn").find(".new-sticky-atc-text").text("SOLD OUT");
      }
      else{
        $(".new-sticky-atc-btn").removeClass("new-sticky-atc--sold");
        $(".new-sticky-atc-btn").find(".new-sticky-atc-text").text("ADD TO CART");
        if(isPreorder == "true"){
          $(".new-sticky-atc-btn").addClass("new-sticky-atc--preorder");
          $(".new-sticky-atc-btn").find(".new-sticky-atc-text").text($(".new-sticky-atc-btn").attr("data-preorder"));
        }
        else{
          $(".new-sticky-atc-btn").removeClass("new-sticky-atc--preorder");
          $(".new-sticky-atc-btn").find(".new-sticky-atc-text").text("ADD TO CART");
        }
      }
    }
    if($(".new-sticky-atc-img").length > 0){
      let sticky_img = $(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).attr("data-sticky-img");
      $(".new-sticky-atc-img").attr("src", sticky_img);
    }
    if($(".new-sticky-atc-price").length > 0){
      let sticky_price = $(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).attr("data-sticky-price");
      $(".new-sticky-atc-price").html(sticky_price);
    }
  }
  let img = $(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).attr("data-img");
  let vimg = $(this).closest("[data-product-blocks]").find(`.new-master-select-li[data-id="${v}"]`).attr("data-vimg");
  $(".new-main-product-swiper-wrapper, .new-main-product-variant-swiper-wrapper").removeClass("active");
  if(vimg == "true"){
    if($(`.new-main-product-variant-swiper-wrapper[data-id="${v}"]`).length > 0){
      $(`.new-main-product-variant-swiper-wrapper[data-id="${v}"]`).addClass("active");
    }
    else{
      $(".new-main-product-swiper-wrapper").addClass("active");
    }
  }
  else{
    $(".new-main-product-swiper-wrapper").addClass("active");
    if(img != "none"){
      let slideSwiper = $(this).closest(".page-content--product").find(`.new-main-product-swiper-wrapper .new-swt-main-swiper`);
      let slide = slideSwiper.find(`.new-swt-main-slide[data-img="${img}"]`);
      if(slide.length > 0){
        let index = parseInt(slide.attr("data-index"));
        slideSwiper[0].swiper.slideTo(index);
      }
    }
  }
})

$(document).on("click", ".new-prod-block-btn", function(){
  let $this = $(this);
  $this.addClass("active");
  let formData = {};
  if($(this).attr("data-preorder") == "true"){
    formData = {
    'items': [{
      'id': $this.attr("data-id"),
      'quantity': 1,
        properties: {
          '_preorder': 'true'
        }
      }]
    };
  }
  else{
    formData = {
    'items': [{
      'id': $this.attr("data-id"),
      'quantity': 1
      }]
    };
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      // document.dispatchEvent(new CustomEvent('cart:build'));
      location.href = '/checkout';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

// Fancybox.bind('[data-fancybox="gallery"]', {
//   // Your custom options for a specific gallery
// });
Fancybox.bind("[data-fancybox]", {
  // Your custom options
});

$(document).on("click", ".new-sticky-atc-option-value", function(){
  let index = $(this).attr("data-option");
  let val = $(this).attr("data-val");
  $(this).parents(".new-sticky-atc-options").removeAttr("open");
  $(`[data-product-blocks] .variant-input-wrap input[data-index="option${index}"][value="${val}"]`).trigger("click");
})

$(document).on("click", function(){
  $(".new-sticky-atc-options").removeAttr("open");
  $(".new-sticky-atc-options").removeClass("active");
})

$(document).on("click", ".new-sticky-atc-options", function(e){
  $(".new-sticky-atc-options").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".new-sticky-atc-options-wrapper").find(".new-sticky-atc-options:not(.active)").removeAttr("open");
  e.stopPropagation();
})

$(document).on("click", ".new-sticky-atc-btn", function(){
  $(".new-main--atc").trigger("click");
})

document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.getElementById('new-sticky-atc-wrapper');
  const atcButton = document.querySelector('.new-main--atc');
  if (!stickyBar || !atcButton) return;
  stickyBar.classList.add('hidden');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.remove('hidden');
        } 
        else {
          stickyBar.classList.add('hidden');
        }
      });
    },
    {
      threshold: 0,
      rootMargin: '0px 0px 0px 0px'
    }
  );
  observer.observe(atcButton);
});

$(function(){
  checkPDPSwiper();
  $(window).resize(function(){
    checkPDPSwiper();
  })
})

function checkPDPSwiper(){
  if($(".new-swt-thumb-swiper-thumb-mobile").length > 0){
    if($(window).width() <= 768){
      $(".new-swt-thumb-swiper-thumb-mobile").removeAttr("direction");
      $(".new-swt-thumb-swiper-thumb-mobile").attr("navigation", "true");
    }
    else{
      $(".new-swt-thumb-swiper-thumb-mobile").attr("direction", "vertical");
      $(".new-swt-thumb-swiper-thumb-mobile").removeAttr("navigation");
    }
  }
}

$(document).on("click", ".new-quick-add-btn", function(e){
  e.preventDefault();
  e.stopPropagation();
  $(this).toggleClass("open");
  $(this).parent().find(".new-quick-add-wrapper").fadeToggle(300);
})
$(document).on("click", ".new-quick-add-wrapper", function(e){
  e.stopPropagation();
})
$(document).on("click", ".new-quick-add-variants-inp", function(){
  let $this = $(this);
  $this.next("label").addClass("active");
  let formData = {};
  if($(this).attr("data-preorder") == "true"){
    formData = {
    'items': [{
      'id': $this.val(),
      'quantity': 1,
        properties: {
          '_preorder': 'true'
        }
      }]
    };
  }
  else{
    formData = {
    'items': [{
      'id': $this.val(),
      'quantity': 1
      }]
    };
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.next("label").removeClass("active");
  });
})